import { Pipe, PipeTransform } from "@angular/core";
import { CleanFilePathService } from "../../../../clean-file/clean-file-path.service";
import { lastField } from "../last-field";

@Pipe({ name: "attrValue" })
export class AttrValuePipe implements PipeTransform {
  constructor(private cleanFilePathService: CleanFilePathService) {}

  public transform(value: any, key: string) {
    switch (key) {
      case "errors.0.stackRecord":
        return this.cleanFilePathService.clean(value.file);
      case "context.browserName":
        return value.name;
      case "context.browser":
      case "context.browserEngine":
        return `${value.name} ${value.version}`;
      case "context.browserPlatform":
        return `${value.os} ${value.platform}`;
      case "context.user":
        return value.email;
      default:
        return value[lastField(key)];
    }
  }
}
